"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _merchant = require("@/api/merchant");
var _score = require("@/api/iot/score");
var _customPage = _interopRequireDefault(require("@/components/customPage"));
var _default = {
  components: {
    customPage: _customPage.default
  },
  data: function data() {
    return {
      loading: true,
      searchForm: {
        merchant_id: '',
        user_name: '',
        mobile: ''
      },
      total: 0,
      tableData: [],
      merchantList: [],
      orderStatusList: []
    };
  },
  mounted: function mounted() {
    this.init();
    this.getOrderStatusList();
    this.getList();
  },
  methods: {
    init: function init() {
      if (this.sMerchantId == 0) {
        this.getMerchantList();
      }
      this.loadQuery();
    },
    loadQuery: function loadQuery() {
      var query = this.$route.query;
      console.log('query', query);
      for (var key in this.searchForm) {
        if (query[key]) {
          this.searchForm[key] = query[key];
        }
      }
    },
    // 检测支付状态
    chkStatusType: function chkStatusType(item) {
      var type = 'info';
      if (item.status == 1) {
        type = 'success';
      } else if (item.status == -1) {
        type = 'warning';
      }
      return type;
    },
    getOrderStatusList: function getOrderStatusList() {
      var _this = this;
      (0, _score.getOrderStatusList)().then(function (res) {
        console.log('getOrderStatusList', res);
        if (res) {
          _this.orderStatusList = res || [];
        }
      });
    },
    getMerchantList: function () {
      var _getMerchantList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res, _this$merchantList;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _merchant.getMerchantList)({
                  status: 1
                });
              case 2:
                res = _context.sent;
                if (res.data) {
                  (_this$merchantList = this.merchantList).push.apply(_this$merchantList, (0, _toConsumableArray2.default)(res.data));
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getMerchantList() {
        return _getMerchantList2.apply(this, arguments);
      }
      return getMerchantList;
    }(),
    getList: function getList(flag) {
      var _this2 = this;
      // flag为true, 则不刷新表格
      var _this$$refs$customPag = this.$refs.customPage,
        page = _this$$refs$customPag.page,
        pageSize = _this$$refs$customPag.pageSize;
      if (!flag) {
        this.tableData = [];
      }
      this.loading = true;
      (0, _score.getScoreOrderList)((0, _objectSpread2.default)({
        page: page,
        pageSize: pageSize
      }, this.searchForm)).then(function (res) {
        _this2.loading = false;
        _this2.tableData = res.data || [];
        _this2.total = res.total;
      });
    },
    // 完成
    success: function success(item) {
      var _this3 = this;
      this.$confirm('您确定处理完成吗?', '完成', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _score.successOrder)({
          id: item.id
        }).then(function (res) {
          _this3.getList(true);
        });
      }).catch(function () {});
    },
    // 退单
    returned: function returned(item) {
      var _this4 = this;
      this.$confirm('您确定要退单吗?', '退单', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _score.returnOrder)({
          id: item.id
        }).then(function (res) {
          _this4.getList(true);
        });
      }).catch(function () {});
    },
    // 批量操作
    handleCommand: function handleCommand(command) {},
    // 查询
    search: function search() {
      this.$refs.customPage.page = 1;
      this.getList();
    },
    // 重置
    reset: function reset() {
      this.searchForm = this.$options.data().searchForm;
      this.getList();
    }
  }
};
exports.default = _default;